import React from 'react';
import store from '../store';
import { RESET_CITY,FILE_IMAGES,typeList,showTimeList,LBFormulaList,answerTimeList,qCountList,maxNumberList,digitsList,YesNoList } from '../config/static';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions  from '@material-ui/core/DialogActions';
import DialogContent  from '@material-ui/core/DialogContent';
import DialogTitle  from '@material-ui/core/DialogTitle';
import ReactPlayer from "react-player";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import LocationOnIcon from '@material-ui/icons//LocationOn';
import EditIcon from '@material-ui/icons//Edit';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Typography from '@material-ui/core/Typography';
import firebase from "firebase/app";
import "firebase/firestore";
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import ImageIcon from '@material-ui/icons/Image';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import Dropzone from "react-dropzone";
import { NotificationManager} from 'react-notifications';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import * as STATIC from '../config/static';
import * as LHELPER from './LessonHelper';
import _ from 'lodash';
import { CSVLink, CSVDownload } from "react-csv";

// const csvData = [
//   ["firstname", "lastname", "email"],
//   ["Ahmed", "Tomi", "ah@smthing.co.com"],
//   ["Raed", "Labes", "rl@smthing.co.com"],
//   ["Yezzi", "Min l3b", "ymin@cocococo.com"]
// ];


const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '90%',
    maxWidth: 680
  },
  textField: {
    minWidth: 200
  },
  input: {
    display: 'none',
  }
});
function searchLabel(array,value)
{
  let rel='';
  let index = array.findIndex(a=>a.value==value);
  if(index>-1)
  {
    rel = array[index].label;
  }
  return rel;
}
var _this;
const defaultSetting = {type:[],
times:1,
rows:3,
showTime:6,
answerTime:10,
qCount:10,
maxNumber:10,
digits:1,
digits1:1,
digits2:1,
point:0,
percent:80,
displaySetting:0,
displayShow:0,
lessThan0:0,
largerThan:0,
roundNumber:0,
isReversed:0,
dr1:0,
dr2:0,
dba:1,
ssp:0,
}

class CreateDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: _.cloneDeep(defaultSetting),
      open: false,
      curWeekIndex:0,
      curWeek:null,
      curDay:null,
      curDayIndex:null,
      csvData:[],
      downloadCSV:false
    }
    _this = this;
  }
  componentDidMount(props)
  {

  }

export(item)
{
  if(item.type.length==0)
  return;
  let questions =  LHELPER.randomQuestionList(item.qCount,item);
//  console.log(questions);
  let headers = [];
  let headers2 = [];
  let csvData = [];
  let data = [];
  let results = [];
  let spaces = [];
  for(let n=0;n<item.rows;n++){
    data[n]=[];
  }
  for(let r=0;r<item.qCount;r++)
  {
    headers.push('C'+(r+1));
    let q = questions[r];
    for(let n=0;n<item.rows;n++){
      data[n].push(q.numbers[n]);
    }
    results.push(q.result);
    spaces.push("");
    headers2.push(q.type);
  }
csvData.push(headers);
  csvData.push(headers2);
  for(let n=0;n<item.rows;n++){
    csvData.push(data[n]);
  }
  csvData.push(spaces);
  csvData.push(results);
  _this.setState({csvData,downloadCSV:true});
}
showDownload(csvData){
  setTimeout(()=>{
    _this.setState({downloadCSV:false});
  },2000)
  return <CSVDownload data={csvData} target="_blank" />;
}



  handleChange = name => event => {
    event.preventDefault();
    const item = _this.state.item;

    item[name] = event.target.value;

    _this.setState({ item });
  }
  handleSettingChange = name => event => {
    event.preventDefault();
    const { item,curDayIndex,curWeekIndex } = this.state;
    let curDay =  item;

    curDay[name] = event.target.value;

    _this.setState({ item });
  }
  handleDelete = (name,value) => {
    const { item,curDayIndex,curWeekIndex } = this.state;
    let curDay =  item;
      let change = curDay[name];

      change = _.without(change,value);
      curDay[name] = change;

      this.setState({
          item
      });
  }

async  CreateItem  (data) {

    const item = data;

    //var check = window.confirm("Do you want to add category?");
    var _this=this;

          var docRef = firebase.firestore().collection("courses").doc();

            docRef.set(item)
              .then(function () {
                item.id = docRef.id;
              //  item.order = item.order?parseInt(item.order):0;
                console.log(item);
                  //store.dispatch({ type: 'CREATE_DISTRICT', item });
                NotificationManager.success("Success!");
                _this.forceUpdate();
              //  _this.setState(RESET_CITY);
                //_this.props.onClose();
              })
              .catch(function (error) {
                console.error(error);
              });






  }

  async SaveItem  (data)  {
    //event.preventDefault();
    const item = data;

    var _this=this;

      const id = item.id;

      firebase.firestore().collection("courses").doc(id).update(item)
        .then(function () {
          item.id = id;
          //item.order = item.order?parseInt(item.order):0;
          //let index = store.getState().CITIES.findIndex(e => e.id === id);
          //store.dispatch({ type: 'UPDATE_DISTRICT', item, index });
          NotificationManager.success("Success!");
        //  _this.setState(RESET_CITY);
          _this.forceUpdate();
        })
        .catch(function (error) {
          console.error(error);
        });

  }
  DeleteItem = (id) => event => {
    var check = window.confirm("Do you want to delete this category?");
    var _this=this;
    if (check === true) {
        firebase.firestore().collection("categories").doc(id).delete().then(()=>{
            NotificationManager.success("Success!");
            _this.props.onClose();
        });
    }

  }
  handleClose = () => event => {
    event.preventDefault();
    //this.setState(RESET_CITY);
    this.props.onClose();
  };
  handleChangeWeek = event=>{
    event.preventDefault();

    this.setState({curWeekIndex:event.target.value,curDayIndex:null})
  }


checkMultiOrDivide(type){

  for(let t of type)
  {
    if(t=="multiple"||t=='divide')
    return true;
  }
  return false;
}
checkDivide(type){

  for(let t of type)
  {
    if(t=='divide')
    return true;
  }
  return false;
}
  render() {
    const { classes, onClose, fullScreen, onChange, ...other } = this.props;
    const { item,csvData,downloadCSV } = this.state;
    let curDay = item;
let width=500;
    return (<div>
      {downloadCSV?this.showDownload(csvData):false}
      {!item ? '' :
        <Dialog onClose={this.props.onClose} open={false} fullScreen={fullScreen} {...other}>
          <DialogTitle>
            <Grid justify="flex-start" direction="row" container>
              <Grid item style={{ marginRight: 8 }}><AllInboxIcon /></Grid>
              <Grid item>
                <Typography variant="title" className={classes.title}>Export</Typography>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent className={classes.container}>
            <Typography variant="body2" color="primary" style={{ marginBottom: 10 }}></Typography>
            <Divider style={{ marginBottom: 5 }} />

            <div>



            <Divider />

              {item!=null?<div>
              <Typography variant="body2" color="primary" style={{ marginTop: 10,color:'black' }}>Settings</Typography>
              <Grid container direction="column" alignItems="center" justify="center" style={{ marginTop: 0 }}>
                <Grid item >
                  <FormControl style={{width:width}}>
                    <InputLabel htmlFor="select-type" shrink style={{ color: '#1B5E20',fontSize:'1.4rem' }}>Type</InputLabel>
                    <Select
                      multiple
                      value={curDay.type}
                      onChange={this.handleSettingChange('type')}
                      input={<Input id="select-type" />}
                      renderValue={selected => (
                          <div className={classes.chips}>
                            {selected.map(value => (
                              <Chip key={value} label={searchLabel(typeList,value)} onDelete={()=>this.handleDelete("type",value)} className={classes.chip} />
                            ))}
                          </div>
                        )}
                    >
                    {typeList.map((t,index)=>{
                      return (<MenuItem key={"TypeItem"+index} value={t.value}>
                    {t.label}
                  </MenuItem>)
                    })}
                    </Select>
                  </FormControl>
                </Grid>
                  <Grid item >
                        <TextField
                            value={curDay.qCount}
                            onChange={this.handleSettingChange('qCount')}
                            label="Number of questions"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*0.5}}
                        >

                        </TextField>
                        <TextField
                            value={curDay.rows}
                            onChange={this.handleSettingChange('rows')}
                            onBlur={this.rownOnBlur}
                            label="Rows"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            inputProps={{
                                style: {
                                  padding: "5px 0px 5px 10px",
                                  textAlign: "center",
                                  height: "60px",
                                  width: "60px",
                                  border: "1px solid",
                                  fontSize: "2rem",
                                  backgroundColor:'#fff8ad'
                                },
                                 min: 3, max: 40
                            }}


                        />


                  </Grid>

                  <Grid item >
                    <TextField
                        value={curDay.digits}
                        onChange={this.handleSettingChange('digits')}
                        label="Digits"
                        placeholder=""
                        type="number"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                            style: { color: '#1B5E20',fontSize:'1.2rem' }
                        }}
                        inputProps={{

                             min: 1, max: 7
                        }}
                        style={{width:width*0.49}}/>

                        <TextField
                            value={curDay.isReversed?curDay.isReversed:0}
                            onChange={this.handleSettingChange('isReversed')}
                            label="Is Super"
                            placeholder=""
                            select
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*0.49}}


                        >
                        {YesNoList.map((t,index)=>{
                          return (<MenuItem key={"LessItem"+index} value={t.value}>
                        {t.label}
                      </MenuItem>)
                        })}
                        </TextField>
                  </Grid>
                  <Grid item >

                        <TextField
                            value={curDay.lessThan0}
                            onChange={this.handleSettingChange('lessThan0')}
                            label="Less Than 0"
                            placeholder=""
                            select
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*0.3}}


                        >
                        {YesNoList.map((t,index)=>{
                          return (<MenuItem key={"LessItem"+index} value={t.value}>
                        {t.label}
                      </MenuItem>)
                        })}
                        </TextField>
                        <TextField
                            value={curDay.largerThan?curDay.largerThan:0}
                            onChange={this.handleSettingChange('largerThan')}
                            label={"Larger Than "+Math.pow(10,curDay.digits)}
                            placeholder=""
                            select
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*0.3}}


                        >
                        {YesNoList.map((t,index)=>{
                          return (<MenuItem key={"LessItem"+index} value={t.value}>
                        {t.label}
                      </MenuItem>)
                        })}
                        </TextField>
                        <TextField
                            value={curDay.roundNumber?curDay.roundNumber:0}
                            onChange={this.handleSettingChange('roundNumber')}
                            label="Round to Digits"
                            placeholder=""
                            select
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*0.3}}


                        >
                        {YesNoList.map((t,index)=>{
                          return (<MenuItem key={"LessItem"+index} value={t.value}>
                        {t.label}
                      </MenuItem>)
                        })}
                        </TextField>

                  </Grid>


                  {this.checkMultiOrDivide(curDay.type)?<Grid item >
                    <TextField
                        value={curDay.digits1}
                        onChange={this.handleSettingChange('digits1')}
                        label="Digits 1"
                        placeholder=""
                        type="number"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                            style: { color: '#1B5E20',fontSize:'1.2rem' }
                        }}
                        inputProps={{

                             min: 1, max: 7
                        }}
                        style={{width:width*0.3}}/>
                        <TextField
                            value={curDay.digits2}
                            onChange={this.handleSettingChange('digits2')}
                            label="Digits 2"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            inputProps={{

                                 min: 1, max: 7
                            }}
                            style={{width:width*0.3}}/>
                  </Grid>:false}
                  {this.checkMultiOrDivide(curDay.type)?<Grid item >

                    <TextField
                        value={curDay.dr1?curDay.dr1:0}
                        onChange={this.handleSettingChange('dr1')}
                        label="From Digit"
                        placeholder=""
                        type="number"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                            style: { color: '#1B5E20',fontSize:'1.2rem' }
                        }}

                        style={{width:width*0.3}}/>
                        <TextField
                            value={curDay.dr2?curDay.dr2:0}
                            onChange={this.handleSettingChange('dr2')}
                            label="To Digit"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}

                            style={{width:width*0.3}}/>
                          {this.checkDivide(curDay.type)?<TextField
                                value={curDay.dba!=undefined?curDay.dba:1}
                                onChange={this.handleSettingChange('dba')}
                                label="Divide by all"
                                placeholder=""
                                select
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                    style: { color: '#1B5E20',fontSize:'1.2rem' }
                                }}
                                style={{width:width*0.3,marginLeft:10}}>
                                {YesNoList.map((t,index)=>{
                                  return (<MenuItem key={"LessItem"+index} value={t.value}>
                                {t.label}
                              </MenuItem>)
                                })}
                              </TextField>:false}
                  </Grid>:false}





              </Grid>
              </div>:false}
            </div>






          </DialogContent>

          <DialogActions style={{ padding: 10 }}>
            <Button onClick={this.handleClose()} size="large">
              <CloseIcon style={{ marginRight: 5 }} />BACK
          </Button>
          {/*!item.id ? '' : <Button onClick={this.DeleteItem(item.id)} size="large" color="primary">
              <DeleteIcon style={{ marginRight: 5 }} /> DELETE </Button>*/}

              <Button onClick={()=>this.export(item)}  size="large" variant="contained" color="secondary">
                Export
        </Button>
          </DialogActions>
        </Dialog>
      }</div>);
  }
}

CreateDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func
};

export default withStyles(styles)(CreateDialog);
